import React, { useState } from 'react';
import { formatAmount, formatCurrency, parseAmount } from '../utils/currency';

// Odaktayken sadece rakamları, odak dışındayken para birimi formatını gösterir
export function CurrencyInput({
	value,
	currency,
	onChange,
	allowDecimals = false,
	...props
}) {
	const [isFocused, setIsFocused] = useState(false);

	const displayValue = isFocused
		? formatAmount(value)
		: Number(value)
		? formatCurrency(value, currency)
		: '';

	return (
		<input
			{...props}
			type="text"
			inputMode={allowDecimals ? 'decimal' : 'numeric'}
			value={displayValue}
			onFocus={() => setIsFocused(true)}
			onBlur={() => setIsFocused(false)}
			onChange={(e) => onChange(parseAmount(e.target.value, allowDecimals))}
		/>
	);
}
